import React, { useEffect, useState } from "react";
import { Button, Col } from "react-bootstrap";
import NotificationService from "../../services/notification.service";
import * as yup from "yup";
import { NotificationTable } from "../allTables/allTable";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

const Notification = () => {
  const navigate = useNavigate();
  const newPage = localStorage.getItem("cricketNotificationPage");
  const newData = localStorage.getItem("cricketNotificationData");
  const [data, setData] = useState([]);
  console.log("🚀 ~ Notification ~ data:", data)
  const [isLoading, setIsLoading] = useState(false);
  const [dataPerPage, setDataPerPage] = useState(
    newData !== null ? newData : 10
  );
  const [pageNumber, setPageNumber] = useState(newPage !== null ? newPage : 1);
  const [totalRows, setTotalRows] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  const handleOpen = async (id, result) => {
    navigate("/cricket-notification/add");
  };

  const getAllUserData = async () => {
    const newPageNumber = localStorage.getItem("cricketNotificationPage");
    if (newPageNumber === null) {
      localStorage.setItem("cricketNotificationPage", 1);
    }
    const newPageData = localStorage.getItem("cricketNotificationData");
    if (newPageData === null) {
      localStorage.setItem("cricketNotificationData", 10);
    }
    const response = await NotificationService.getAllNotification(
      pageNumber,
      dataPerPage,
      "CRICKET"
    );
    setData(response.data.data);
    setTotalRows(response.data.totalRecord);
  };

  useEffect(() => {
    getAllUserData();
    localStorage.setItem("cricketNotificationPage", pageNumber);
    localStorage.setItem("cricketNotificationData", dataPerPage);
  }, [pageNumber, dataPerPage]);

  const handlePerPageChange = (newPerPage, newPageNumber) => {
    setIsLoading(true);
    setDataPerPage(newPerPage);
    setPageNumber(newPageNumber);
    setIsLoading(false);
  };

  const handlePageChange = (newPageNumber) => {
    setIsLoading(true);
    setPageNumber(newPageNumber);
    setIsLoading(false);
  };

  return (
    <>
      <div className="page-header2"></div>
      <div className="row">
        <Col
          sm={12}
          md={6}
          lg={12}
          xl={12}
          className="ms-auto mt-auto d-flex"
          style={{ justifyContent: "end", alignItems: "baseline" }}
        >
          <div
            className="me-auto d-flex justify-content-start"
            style={{ fontWeight: 600, fontSize: "20px", marginBottom: "10px" }}
          >
            CRICKET NOTIFICATION
          </div>
          <div
            className="custom-card text-end  pointer"
            style={{ marginRight: "18px", marginTop: "4px" }}
          >
            <Button
              className="text-white"
              onClick={() => handleOpen("")}
              style={{ marginLeft: "15px", marginTop: "-3px" }}
            >
              <i className="fas fa-plus"></i> &nbsp; Add Notification
            </Button>
          </div>
        </Col>
      </div>
      <NotificationTable
        data={data}
        totalRows={totalRows}
        dataPerPage={dataPerPage}
        handlePerPageChange={handlePerPageChange}
        handlePageChange={handlePageChange}
        isLoading={isLoading}
        getAllUser={getAllUserData}
        handleOpen={handleOpen}
        getAllUserData={getAllUserData}
        type="cricket"
        pageNumber={pageNumber}
      />
    </>
  );
};

export default Notification;
